import React from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import TimesIcon from 'src/app/assets/icons/ico-times.svg'
import { Button } from 'src/components/Button'
import { useGetIsPlacingNextRaceBet, useNextRaceBetActions } from 'src/store/nextRaceBet'

type Props = Readonly<{
  isRaceReady: boolean
  gameType?: string
}>

export function NextRaceBetHeader({ isRaceReady, gameType }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  const nextRaceBetActions = useNextRaceBetActions()
  const isPlacingNextRaceBet = useGetIsPlacingNextRaceBet()

  if (
    !isPlacingNextRaceBet ||
    isRaceReady ||
    gameType === 'irl_alt' ||
    gameType === 'duck_river' ||
    gameType === 'snow_run' ||
    gameType === 'social_betting'
  ) {
    return null
  }

  return (
    <Button
      className="btn-close-bet-on-next-race"
      onClick={() => {
        nextRaceBetActions.setIsPlacingNextRaceBet(false)
      }}
      useDefaultClasses={false}
    >
      <span>{t('Place bet on next game')}</span>
      <TimesIcon />
    </Button>
  )
}
